import React, { useState } from "react";
import api from "../api";
import { philippinesToday, requestError } from "../utils/publicApartments";

const blank = { name: "", email: "", phone: "", message: "", preferred_date: "", preferred_time: "" };
export default function GuestInquiryForm({ unit, viewing = false }) {
  const [form, setForm] = useState({ ...blank });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const change = (key) => (event) => { setForm((prev) => ({ ...prev, [key]: event.target.value })); setSuccess(""); };
  async function submit(event) {
    event.preventDefault();
    if (busy) return;
    setError(""); setSuccess(""); setBusy(true);
    try {
      await api.post("/public/inquiries", {
        ...Object.fromEntries(Object.entries(form).map(([key, value]) => [key, value.trim()])),
        apartment_id: unit?.id || null,
        inquiry_type: viewing ? "viewing" : unit ? "apartment" : "general",
        preferred_date: viewing ? form.preferred_date : null,
        preferred_time: viewing ? form.preferred_time : null,
      }, { timeout: 15000 });
      setSuccess(viewing ? "Viewing request received. Our team will contact you to confirm the appointment. Your preferred time is not booked yet." : "Your inquiry has been received. Our team will contact you soon.");
      setForm({ ...blank });
    } catch (err) { setError(requestError(err)); }
    finally { setBusy(false); }
  }
  return <form onSubmit={submit} className="guest-inquiry-form">
    <div className="inquiry-fields">
      <label>Your name<input required maxLength={255} autoComplete="name" value={form.name} onChange={change("name")} /></label>
      <label>Email address<input required type="email" maxLength={255} autoComplete="email" value={form.email} onChange={change("email")} /></label>
      <label>Phone number{!viewing && " (optional)"}<input required={viewing} type="tel" maxLength={30} autoComplete="tel" value={form.phone} onChange={change("phone")} /></label>
      {viewing && <><label>Preferred date<input required type="date" min={philippinesToday()} value={form.preferred_date} onChange={change("preferred_date")} /></label><label>Preferred time (Philippines)<input required type="time" value={form.preferred_time} onChange={change("preferred_time")} /></label></>}
      <label className="inquiry-message">{viewing ? "Tell us about your visit" : "Your message"}<textarea required maxLength={4000} rows={4} value={form.message} onChange={change("message")} placeholder={viewing ? "Number of visitors, questions, or anything we should know." : "How can we help?"} /></label>
    </div>
    {error && <p className="portal-message portal-message-error" role="alert">{error}</p>}
    {success && <p className="portal-message" role="status">{success}</p>}
    <button className="portal-button" disabled={busy} type="submit">{busy ? "Sending…" : viewing ? "Send viewing request" : "Send inquiry"} <span aria-hidden="true">↗</span></button>
    {viewing && <p className="portal-fine-print">No account needed. Viewing times are subject to confirmation by our team.</p>}
  </form>;
}
